/**
 * tracks webchat start
 * @param trackingData
 */
import {track} from '@vfde-fe/sails_core';
import {createTrackingChatInteraction} from 'Container/Tracking/helper/createTrackingChatInteraction';
import {createTrackingError} from 'Container/Tracking/helper/createTrackingError';
import {
    TRACKING_WEBCHAT_ERROR,
    TRACKING_WEBCHAT_INTERACTION,
} from 'Container/Tracking/constants';

/**
 * Tracks the webchat start
 * @param trackingData
 */
export function trackWebChatInteraction (trackingData, trackingAction) {
    const trackingPayload = createTrackingChatInteraction(trackingData);

    return track(
        {
            type: trackingAction,
        },
        TRACKING_WEBCHAT_INTERACTION,
        trackingPayload,
    );
}
/**
 * tracks webchat failed to start
 * @param trackingData
 */
export function trackWebChatError (trackingData, trackingAction) {
    const trackingPayload = createTrackingError(trackingData);

    return track(
        {
            type: trackingAction,
        },
        TRACKING_WEBCHAT_ERROR,
        trackingPayload,
    );
}
